/**
 * This is a small adaptor for apps using esri-loader's `loadModules` function in 4.x
 * essentially we trick loadModules into thinking we have a dojo loader declared
 * then we just provide modules from @arcgis/core
 */
import * as arcade from "@arcgis/core/arcade";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Geometry from "@arcgis/core/geometry/Geometry";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import * as intl from "@arcgis/core/intl";
import Search from "@arcgis/core/widgets/Search";
import Sketch from "@arcgis/core/widgets/Sketch";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import Point from "@arcgis/core/geometry/Point";
import MapView from "@arcgis/core/views/MapView";
import esriRequest from "@arcgis/core/request";
import * as jsonUtils from "@arcgis/core/symbols/support/jsonUtils";
import Measurement from "@arcgis/core/widgets/Measurement";
import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";
import Conversion from "@arcgis/core/widgets/CoordinateConversion/support/Conversion";
import Legend from "@arcgis/core/widgets/Legend";
import Handles from "@arcgis/core/core/Handles";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import Compass from "@arcgis/core/widgets/Compass";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import WebMap from "@arcgis/core/WebMap";
import PortalItemResource from "@arcgis/core/portal/PortalItemResource";
import SearchViewModel from "@arcgis/core/widgets/Search/SearchViewModel";

// @ts-ignore
window.require = function require(modulePaths: string[], cb) {
  const moduleMap = {
    "esri/arcade": arcade,
    "esri/layers/FeatureLayer": FeatureLayer,
    "esri/geometry/Geometry": Geometry,
    "esri/geometry/SpatialReference": SpatialReference,
    "esri/geometry/Point": Point,
    "esri/geometry/geometryEngine": geometryEngine,
    "esri/Graphic": Graphic,
    "esri/layers/GraphicsLayer": GraphicsLayer,
    "esri/intl": intl,
    "esri/WebMap": WebMap,
    "esri/portal/PortalItemResource": PortalItemResource,
    "esri/widgets/Search": Search,
    "esri/widgets/Sketch": Sketch,
    "esri/widgets/Sketch/SketchViewModel": SketchViewModel,
    "esri/views/MapView": MapView,
    "esri/widgets/Legend": Legend,
    "esri/widgets/Compass": Compass,
    "esri/widgets/ScaleBar": ScaleBar,
    "esri/core/Handles": Handles,
    "esri/request": esriRequest,
    "esri/core/reactiveUtils": reactiveUtils,
    "esri/symbols/support/jsonUtils": jsonUtils,
    "esri/widgets/Measurement": Measurement,
    "esri/widgets/CoordinateConversion": CoordinateConversion,
    "esri/widgets/CoordinateConversion/support/Conversion": Conversion,
    "esri/widgets/Search/SearchViewModel": SearchViewModel,
  };
  const modules = modulePaths.map((name) => {
    const module = moduleMap[name];
    if (!module) {
      console.error(`${name} not defined. Please add to utils/require.ts`);
    }
    return module;
  });
  cb.apply(null, modules);
};
// this has to be defined to fool esri-loader
// @ts-ignore
window.require.on = function () {
  return { remove: () => {} };
};
